import {ArticleType} from '@strapi/types';

const mapping: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ь: '',
  ы: 'y',
  ъ: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
  ' ': '_',
};

export const FAQ_ANCHOR_ID = 'faq';
export const SIMILAR_ARTICLES_ANCHOR_ID = 'similar_articles';
export const FEATURING_BLOCK_ANCHOR_ID = 'featuring';

type TocEntry = {
  blockId?: number; // missing for faq/similar/etc, present for normal content blocks
  title: string;
  anchor: string;
};

const preprocessTitle = (title: string) => {
  if (title.match(/^[0-9]+\./)) {
    // убираем нумерацию в заголовках, если она есть
    const indexOfDot = title.indexOf('.');
    return title.slice(indexOfDot + 1).trim();
  }
  return title.trim();
};

const formatTitleToAnchor = (title: string) => {
  return [...title.toLowerCase()]
    .map((symbol) => (symbol.match(/[a-z]/) ? symbol : mapping[symbol]))
    .filter(Boolean)
    .join('');
};

export type TableOfContents = {
  entries: Array<TocEntry>;
  blockIdToAnchor: Record<number, string>;
};

export const generateTableOfContentsForArticle = (
  article: ArticleType,
): TableOfContents => {
  const takenAnchors: string[] = [
    FAQ_ANCHOR_ID,
    SIMILAR_ARTICLES_ANCHOR_ID,
    FEATURING_BLOCK_ANCHOR_ID,
  ];
  const entries: Array<TocEntry> = [];
  for (const item of article.articleContentBlocks) {
    if (item.title) {
      const title = preprocessTitle(item.title);
      let anchor = formatTitleToAnchor(title);
      if (takenAnchors.includes(anchor)) {
        anchor += `_${item.id}`;
      }
      takenAnchors.push(anchor);
      entries.push({
        blockId: item.id,
        title,
        anchor,
      });
    }
  }
  if (article.faq) {
    entries.push({
      anchor: FAQ_ANCHOR_ID,
      title: preprocessTitle(article.faq.title),
    });
  }
  if (article.featuring) {
    entries.push({
      anchor: FEATURING_BLOCK_ANCHOR_ID,
      title: preprocessTitle(article.featuring.title),
    });
  }
  if (article.similar) {
    entries.push({
      anchor: SIMILAR_ARTICLES_ANCHOR_ID,
      title: preprocessTitle(article.similar.title),
    });
  }
  return {
    entries,
    blockIdToAnchor: entries.reduce(
      (acc, {blockId, anchor}) => {
        if (blockId) {
          acc[blockId] = anchor;
        }
        return acc;
      },
      {} as Record<number, string>,
    ),
  };
};
